export type ModeType = Mode.WithHandler | Mode.Modal

export const enum TuringAttr {
  DataSiteKey = 'data-sitekey',
  DisableBotD = 'disable-botd',
  Debug = 'turing-debug',
  ServerUrl = 'turing-server-url',
  Spot = 'turing-spot',
}

export const enum Mode {
  WithHandler = 'withHandler',
  Modal = 'modal',
}

export const enum State {
  Unexpected = -100,
  Undefined = -1,
  Success = 1,
  NoSiteKey = 101,
  ManyForms = 102,
  ManyTuringSpot = 103,
  NeedInit = 104,
  NoForms = 105,
  NoTuringSpot = 106,
}

/**
 * Options for Turing class loading
 */
export interface InitOptions {
  /**
   * Optional endpoint for the server-side Turing API.
   */
  endpoint?: string

  /**
   * Whether to print debug messages to the console.
   * Required to ease investigations of problems.
   * Default value is false.
   */
  debug?: boolean
}

/**
 * Represents the challenge framework error.
 */
class TuringError extends Error {
  state: State

  /**
   * Creates a new TuringError.
   *
   * @class
   */
  constructor(state: State, message: string) {
    super(message)
    this.state = state
    this.name = 'TuringError'
  }
}

export function errorNoSiteKey(msg: string): TuringError {
  return new TuringError(State.NoSiteKey, msg)
}

export function errorNoForm(msg: string): TuringError {
  return new TuringError(State.NoForms, msg)
}

export function errorManyForms(msg: string): TuringError {
  return new TuringError(State.ManyForms, msg)
}

export function errorNoTuringSpot(msg: string): TuringError {
  return new TuringError(State.NoTuringSpot, msg)
}

export function errorManyTuringSpots(msg: string): TuringError {
  return new TuringError(State.ManyTuringSpot, msg)
}

export function errorNeedInit(msg: string): TuringError {
  return new TuringError(State.NeedInit, msg)
}

export function errorUnexpected(msg: string): TuringError {
  return new TuringError(State.Unexpected, msg)
}
